import {put, takeLatest, call} from 'redux-saga/effects';
import * as paymentService from "../../../services/paymentService";
import {
    REMOVE_CARD,
    REMOVE_CARD_SUCCESS,
    REMOVE_CARD_ERROR,
}
    from "../../actions/payment"

function* removeCardSaga(action) {
    try {
        const data=yield call(paymentService.RemoveCard,action.payload)
        
        if(data.outbound.rawData.Sonuc===1)
        {
            yield put({
                type: REMOVE_CARD_SUCCESS,
                payload: action.payload.payload.ksGuid
            })
          }
        else {
            yield put({
                type: REMOVE_CARD_ERROR,error: data.outbound.rawData.Sonuc_Str
            })
        }


    } catch (error) {
        yield put({
            type: REMOVE_CARD_ERROR,error: error.data
        })
    }
}


export function* removeCardSagaWatcher() {
    yield takeLatest(REMOVE_CARD, removeCardSaga)
}